export default "__VITE_ASSET__CVgvhVUb__"